import React from 'react'
import { observer } from 'mobx-react'
import { classNames, useThrottle } from '@dt/fe-utils'
import { cartMobx, doComboMobx, doProductMobx, menuMobx, productMobx, restaurantConfig } from 'restaurant'
import { ProductImage, SoldoutFoldBar, Tags } from 'components'
import CashierController from 'controllers/cashierController'
import { filter, sortBy } from '@dt/fe-utils/dist/lodash'

interface IProps {
}

const AboardFixedGroup: React.FC<IProps> = ({ }) => {
  const { doCombo, groupNoProductPkReadyMap } = doComboMobx

  const handleClick = useThrottle((product) => {
    doProductMobx.pick({ cartItem: product, groupNo: product.groupNo, isCombo: true })
    CashierController.openProductDetail(product, {
      type: 'combo',
      scaleNo: product.scaleNo,
      targetNo: product.groupNo,
    })
  }, 1000)

  return (
    <div className='combo-group-list'>
      {
        doCombo?.productGroups.map(group => {
          // 售罄子餐品数量
          const soldoutCnt = filter(group?.productGroupDetails, product => productMobx.noToViewProductMap?.[product.productNo].saleCnt === 0).length
          const showSoldout = menuMobx.openFoldSoldout === 1 && soldoutCnt > 0
          const soldoutKey = `${doCombo.no}_${group.no}`
          const productGroupDetails = !showSoldout || menuMobx.foldSoldoutMap?.[soldoutKey] === true ? sortBy(group?.productGroupDetails || [], (product) => productMobx.noToViewProductMap?.[product.productNo].saleCnt === 0 ? 1 : 0) : filter(group?.productGroupDetails, product => productMobx.noToViewProductMap?.[product.productNo].saleCnt !== 0)
          return (
            <div className='group-item' key={group.no}>
              <div className='group-title'>{i18n.t('newCart.comboContent')}</div>
              {
                productGroupDetails?.map(product => {
                  const soldout = productMobx.noToViewProductMap?.[product.productNo].saleCnt === 0
                  return (
                    <div className={classNames('product-item', { 'sold-out': soldout })} data-cypid={'aboardFixedGroup_px_' + product?.pk} key={product.pk} onClick={() => handleClick({ ...product, groupNo: group.no })}>
                      <div className='item-detail'>
                        <ProductImage color={!product.pic && restaurantConfig.displayMode === 'waterfall' ? product.productNo : ''} width={40} imgSrc={product.pic} />
                        <div className=''>
                          <strong>{product.name}</strong>
                          <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} disableTogo={cartMobx.info.eatType !== 'dinein' && !product.isCanTogo} />
                          {product.intro ? <div className='product-intro' dangerouslySetInnerHTML={{ __html: product.intro }}></div> : ''}
                          <div className='product-option'>
                            {product.scaleName ? product.scaleName : ''}
                            {product.scaleName && (!groupNoProductPkReadyMap[group.no][product.pk] || product.modifierStr) ? ',' : ''}
                            {
                              !groupNoProductPkReadyMap[group.no][product.pk] ? (
                                <span>{i18n.t('newCart.modifierTips')}</span>
                              ) : (<div dangerouslySetInnerHTML={{ __html: product.modifierHtml }}></div>)
                            }
                          </div>
                        </div>
                      </div>
                      <div className='item-operate'>
                        {
                          !soldout && (
                            product.modifierGroups.length ? (
                              <div className='button'>
                                <i className='iconfont icon-add' />
                                {i18n.t('newCart.modifier')}
                              </div>
                            ) : ''
                          )
                        }
                        {soldout && <span className='sold-out-msg'>{i18n.t('common.soldout')}</span>}
                      </div>
                    </div>
                  )
                })
              }
              {!!showSoldout && (
                <SoldoutFoldBar
                  cnt={soldoutCnt}
                  className='combo-product-item'
                  show={menuMobx.foldSoldoutMap?.[soldoutKey] === true}
                  no={soldoutKey}
                  from='combo'
                />
              )}
            </div>
          )
        })
      }
    </div>
  )
}

export default observer(AboardFixedGroup)
